import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import useMediaQuery from '@/helpers/hooks/useMediaQuery';
import axios from 'axios';
import PageWrapper from '@/components/SupportSection/shared/PageWrapper';
import SupportReturnStatus from '@/components/SupportSection/SupportReturnStatus';
import { WordPressAPI } from '@/config';

const ReturnStatusSupport = ({ data }) => {
  const {
    hero_title,
    mobile_title
  } = data;
  const isMobile = useMediaQuery('(max-width: 576px)');

  const [breadcrumb, setBreadcrumb] = useState('');

  useEffect(() => {
    if (isMobile) {
      setBreadcrumb(mobile_title);
    } else {
      setBreadcrumb(hero_title);
    }
  }, [isMobile]);

  return (
    <PageWrapper data={data} breadcrumb={breadcrumb}>
      <SupportReturnStatus data={data} />
    </PageWrapper>
  );
}



export const getStaticProps = async () => {
  let pageNumber;
  if (WordPressAPI.pages.includes('marketing')) {
    pageNumber = '20849'
  } else {
    pageNumber = '20595'
  }
  const { data } = await axios.get(`${WordPressAPI.pages}/${pageNumber}`);

  return {
    props: {
      data: data.acf,
    },
    // revalidate: 1,
  };
};

ReturnStatusSupport.propTypes = {
  data: PropTypes.object,
};

export default ReturnStatusSupport;